import React, { useState } from 'react';
import { db } from './firebase';
import { collection, addDoc } from 'firebase/firestore';

import PageTitle from '../components/pagetitle/PageTitle';
import Faq3 from '../components/faqs/Faq3';
import dataFaqs from '../assets/fake-data/data-faq';
import Footer from '../components/footer/Footer';
import img from '../assets/images/contact/contact.png';

function Contact(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, 'contacts'), {
                name,
                email,
                phone,
                subject,
                message,
                createdAt: new Date()
            });
            alert('Message sent successfully!');
            setName(''); setEmail(''); setPhone(''); setSubject(''); setMessage('');
        } catch (error) {
            alert('Failed to send message.');
            console.error(error);
        }
    };

    return (
        <div className='wrapper'>
            <PageTitle title='Contact' />

            <section className="touch">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center">
                                <h6 className="sub-heading"><span>Get in Touch!</span></h6>
                                <h3 className="heading">Let’s Start Working <br />Together</h3>
                            </div>
                            <div className="touch__main">
                                <div className="info">
                                    <h5>Contact information</h5>
                                    <ul className="list">
                                        <li>
                                            <p>Regus Bangkok, Exchange Tower,
388 Sukhumvit Road,
Khlong Toei, Bangkok 10110, Thailand</p>
                                        </li>
                                        <li>
                                            <p>+66962155475</p>
                                        </li>
                                        <li>
                                            <p>support@Pipplustech.com</p>
                                        </li>
                                    </ul>
                                    <div className="image">
                                        <img src={img} alt="Contact" style={{ width: '100%', borderRadius: '8px' }} />
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit} className="form-box">
                                    <div className="row">
                                        <div className="col">
                                            <label>Your name</label>
                                            <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                                        </div>
                                        <div className="col">
                                            <label>Your email</label>
                                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label>Your phone</label>
                                            <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                                        </div>
                                        <div className="col">
                                            <label>Subject</label>
                                            <select className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} required>
                                                <option value="">Select</option>
                                                <option value="Support">Support</option>
                                                <option value="Partnership">Partnership</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label>Message</label>
                                            <textarea className="form-control" value={message} onChange={(e) => setMessage(e.target.value)} required rows="6"></textarea>
                                        </div>
                                    </div>
                                    <div className="row mb-0">
                                        <div className="col">
                                            <button type="submit" className="action-btn"><span>Send Now</span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="map">
                <div className="container">
                    <div className="row">
                        <div className="map__main">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.60697511721!2d55.275134675115304!3d25.216473430920228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f428cd916c7f9%3A0x9520894d0e5f1854!2sAl%20Moosa%20Tower%202%20-%20Sheikh%20Zayed%20Rd%20-%20near%20Emirates%20Tower%20Metro%20Station%20-%20Trade%20Centre%20-%20Trade%20Centre%201%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1749116207145!5m2!1sen!2sin"
                                width="100%"
                                height="600"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="PipPlus Tech Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            <Faq3 data={dataFaqs} />
            <Footer />
        </div>
    );
}

export default Contact;
